import React from 'react'
import { Col, Row } from "react-bootstrap";
import { Container } from "react-bootstrap";
import AdminSideBar from '../../Components/DashboardComponents/AdminSideBar';
import NavBarDashboard from '../../Components/DashboardComponents/NavBarDashboard';
import AdminBookingSubs from '../../Components/DashboardComponents/BookingAndSubscriptions/AdminBookingSubs';
const AdminBooking = () => {
    return (
        <div>

            <Row className="py-3">
                <Col sm="5" xs="3" md="2" lg="2">
                    <AdminSideBar />
                </Col>
                <Col sm="7" xs="9" className='px-5' md="10" lg="10">
                    <NavBarDashboard />
                    <AdminBookingSubs />
                </Col>
            </Row>

        </div>
    )
}

export default AdminBooking
